var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"steps"},_vm._l((_vm.steps),function(step,index){return _c('div',{key:step,staticClass:"step",class:{ done: _vm.currentStep > index }})}),0),_c('div',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }